import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsProductsApplinksRoute: InvariantJiraRoute = {
	name: 'global-settings-products-applinks',
	path: '/plugins/servlet/applinks/listApplicationLinks',
};
